import { render, staticRenderFns } from "./help-list.vue?vue&type=template&id=52b0b0f6&scoped=true&"
import script from "./help-list.vue?vue&type=script&lang=ts&"
export * from "./help-list.vue?vue&type=script&lang=ts&"
import style0 from "./help-list.vue?vue&type=style&index=0&id=52b0b0f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0b0f6",
  null
  
)

export default component.exports